module.exports = __webpack_public_path__ + "media/application/images/finger-print-green-8cdbce4564269143db533e5ffef791e7.png";